import React from "react";

import img1 from "assets/svg/undraw_business_decisions_gjwy.svg";
import img2 from "assets/svg/undraw_Business_plan_re_0v81.svg";
import img3 from "assets/svg/undraw_buy_house_560d.svg";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "black",
    width: "100%",
    //height: "100vh",
    padding: theme.spacing(4),
  },
  paper: {
    width: "100%",
    background: "transparent",
    color: "white",
    marginTop: "5%",
    marginBottom: "5%",
    textAlign: "center",
    fontFamily: "sans-serif",
    //padding: theme.spacing(2),
    //border: "1px solid lightgray",
    // alignItems: "center",
  },
  media: {
    width: "100%",
    height: 500,
  },
}));

function MoreInfo() {
  const classes = useStyles();

  return (
    <div>
      <div id="feature" className={classes.root}>
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="center"
          spacing={3}
        >
          <Grid item xs={12}>
            <Paper className={classes.paper}>
              <Typography gutterBottom variant="h3" component="h2">
                LIGHTNING FAST WORKFLOW
              </Typography>
              <Typography
                gutterBottom
                variant="h4"
                component="h3"
                color="secondary"
                align="center"
              >
                Data-driven insights
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Paper className={classes.paper}>
              <CardMedia
                //className={classes.media}
                component="img"
                alt="Contemplative Reptile"
                height="100%"
                image={img1}
                title="Contemplative Reptile"
              />
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Paper className={classes.paper}>
              <CardContent>
                <Typography gutterBottom variant="h4" component="h2">
                  DASHBOARD WORKFLOW
                </Typography>
                <Typography
                  gutterBottom
                  variant="h5"
                  component="h2"
                  color="primary"
                  align="left"
                >
                  Data-driven insights
                </Typography>
                <Typography
                  variant="body1"
                  color="initial"
                  component="p"
                  align="left"
                >
                  Lizards are a widespread group of squamate reptiles, with over
                  6,000 species, ranging across all continents except Antarctica
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua
                  — Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat.
                </Typography>
              </CardContent>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Paper className={classes.paper}>
              <CardContent>
                <Typography gutterBottom variant="h4" component="h2">
                  REPORT DATA IN REALTIME
                </Typography>
                <Typography
                  gutterBottom
                  variant="h5"
                  component="h2"
                  color="primary"
                  align="left"
                >
                  Data-driven insights
                </Typography>
                <Typography
                  variant="body1"
                  color="initial"
                  component="p"
                  align="left"
                >
                  Lizards are a widespread group of squamate reptiles, with over
                  6,000 species, ranging across all continents except Antarctica
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua
                  — Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat.
                </Typography>
              </CardContent>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Paper className={classes.paper}>
              <CardMedia
                //className={classes.media}
                component="img"
                alt="Contemplative Reptile"
                height="100%"
                image={img2}
                title="Contemplative Reptile"
              />
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Paper className={classes.paper}>
              <CardMedia
                //className={classes.media}
                component="img"
                alt="Contemplative Reptile"
                height="100%"
                image={img3}
                title="Contemplative Reptile"
              />
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Paper className={classes.paper}>
              <CardContent>
                <Typography gutterBottom variant="h4" component="h2">
                  MORE BENEFITS TO FARMER
                </Typography>
                <Typography
                  gutterBottom
                  variant="h5"
                  component="h2"
                  color="primary"
                  align="left"
                >
                  Data-driven insights
                </Typography>
                <Typography
                  variant="body1"
                  color="initial"
                  component="p"
                  align="left"
                >
                  Lizards are a widespread group of squamate reptiles, with over
                  6,000 species, ranging across all continents except Antarctica
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua
                  — Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat.
                </Typography>
              </CardContent>
            </Paper>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default MoreInfo;
